import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';
import DarkSupport from '../../assets/images/icons/dark-support.png'
import LightSupport from '../../assets/images/icons/light-support.png'
import { useSelector } from 'react-redux';

export default function ContactBox({isOpen=false,close}) {
    const { t } = useTranslation();
    const [open, setOpen] = useState(isOpen);

    const content = useRef(null);
    const { theme ,user} = useSelector(store => store)
    const phone_number = useMemo(()=>{
        if(user.type === 'user'){
            return '09964080473'//farshi
        }else {
            return '09966935907'//mohamadpur
        }
    },[user.type])

    useEffect(() => {
        function handleClickOutside(event) {
            if (content.current && !content.current.contains(event.target)) {
                setOpen(false);
                close && close()
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [content]);

    return (
        <div className='content-box'>
            {!close && <span className='content-button' onClick={() => setOpen(true)}>
                {/* <i className='fas fa-headset' /> */}
                <img className='contact-icon' src={theme === 'light' ? LightSupport :DarkSupport} alt="support"/>
            </span>}
            <Modal visible={open}>
                <div className='modal-content text-center p10' ref={content}>
                    <span className='title-icon'>
                    {/* <i className='fas fa-headset' /> */}
                    <img src={theme === 'light' ? LightSupport :DarkSupport} alt="support"/>
                    </span>
                    <p className='content-box-title'>
                        {t('Ways to support you')}
                    </p>
                    {/* <a
                        href='whatsapp://send?phone=+989304058655'
                        className='btn btn-circle btn-whatsapp btn-block mt20 contact-btn'
                        //style={{ width: 'auto' }}
                    >
                        ارتباط از طریق واتس اپ
                        <i className='fab fa-whatsapp ml10' />
                    </a> */}
                    <a 
                        // href='tel:02191065151' 
                        href={`tel:${phone_number}`}
                        className='btn btn-circle btn-white-purple btn-block mt10 contact-btn'
                         //style={{ width: 'auto' }}
                         >
                        {t('Phone call contact')}
                        <i className='fas fa-phone ml10' />
                    </a>
                    <p className='description mt20'>
                        {/* {t('We answer you as soon as possible')} */}
                        ما مشتاقانه منتظر پاسخ گویی به شما هستیم .
                    </p>
                </div>
            </Modal>
        </div>
    );

}